// AYA PRO — Assistant business (LLM persona pro, propose les avocats partenaires).
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ProShell from "@/pro/ProShell";
import { getProProfile, PROFILE_META } from "@/pro/proSpace";

const API = process.env.REACT_APP_BACKEND_URL || "";

const SUGGESTIONS = [
  "Un client refuse de payer, que faire ?",
  "Comment importer depuis la Chine sans me faire arnaquer ?",
  "Combien coûte la patente pour ma boutique ?",
];

export default function ProAssistantPage() {
  const navigate = useNavigate();
  const [profile] = useState(getProProfile());
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const endRef = useRef(null);

  useEffect(() => {
    endRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages, busy]);

  const send = async (text) => {
    const msg = (text || input).trim();
    if (!msg || busy) return;
    setInput("");
    const history = messages.map((m) => ({ role: m.role, content: m.content }));
    setMessages((prev) => [...prev, { role: "user", content: msg }]);
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/v3/pro-space/assistant`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: msg, history, profile }),
      });
      const d = await r.json();
      setMessages((prev) => [...prev, { role: "assistant", content: d?.ok ? d.text : "Désolée, je suis indisponible pour le moment. Réessayez dans un instant." }]);
    } catch {
      setMessages((prev) => [...prev, { role: "assistant", content: "Erreur réseau — vérifiez votre connexion et réessayez." }]);
    } finally {
      setBusy(false);
    }
  };

  const meta = PROFILE_META[profile] || PROFILE_META.commercant;

  return (
    <ProShell>
      <button className="pro-back" data-testid="pro-assistant-back-btn" onClick={() => navigate("/pro")}>
        ← Retour à l'accueil PRO
      </button>
      <div className="pro-hero">
        <h1 data-testid="pro-assistant-title">✨ Assistant <span>AYA PRO</span></h1>
        <p>Conseils business adaptés à votre profil {meta.icon} {meta.label} — litiges, fournisseurs, taxes, financement.</p>
      </div>

      <div className="pro-chat-list" data-testid="pro-chat-list">
        {messages.length === 0 && (
          <div className="pro-grid">
            {SUGGESTIONS.map((s) => (
              <button key={s} className="pro-cat-card" style={{ cursor: "pointer", textAlign: "left" }} data-testid="pro-suggestion-btn" onClick={() => send(s)}>
                <span className="pro-cat-desc" style={{ fontSize: 13, color: "#C9C0AC" }}>{s}</span>
              </button>
            ))}
          </div>
        )}
        {messages.map((m, i) => (
          <div key={i} className={`pro-bubble ${m.role === "user" ? "pro-bubble-user" : "pro-bubble-ai"}`} data-testid={`pro-msg-${m.role}`}>
            {m.content}
          </div>
        ))}
        {busy && (
          <div className="pro-bubble pro-bubble-ai" data-testid="pro-typing-indicator">
            <span className="pro-typing"><span /><span /><span /></span>
          </div>
        )}
        <div ref={endRef} />
      </div>

      <div className="pro-chat-inputbar">
        <input
          className="pro-chat-input"
          data-testid="pro-chat-input"
          placeholder="Votre question business…"
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") send(); }}
        />
        <button className="pro-chat-send" data-testid="pro-chat-send-btn" disabled={busy || !input.trim()} onClick={() => send()}>
          ➤
        </button>
      </div>
    </ProShell>
  );
}
